
const getModules = {
  hero: () => import(
		/* webpackChunkName: "hero" */ "./hero/hero"
  ),
  imageFull: () => import(
		/* webpackChunkName: "imageFull" */ "./image-full/image-full"
  ),
  numbers: () => import(
		/* webpackChunkName: "numbers" */ "./numbers/numbers"
  ),
  editorial: () => import(
		/* webpackChunkName: "editorial" */ "./editorial/editorial"
  ),
  frames: () => import(
		/* webpackChunkName: "frames" */ "./frames/frames"
  ),
  productIndex: () => import(
		/* webpackChunkName: "productIndex" */ "./product-index/product-index"
  ),
  productDetail: () => import(
		/* webpackChunkName: "productDetail" */ "./product-detail/product-detail"
  ),
  stickybar: () => import(
		/* webpackChunkName: "stickybar" */ "./stickybar/stickybar"
  ),
  masthead: () => import(
		/* webpackChunkName: "masthead" */ "./masthead/masthead"
  ),
  highlights: () => import(
		/* webpackChunkName: "highlights" */ "./highlights/highlights"
  ),
  contacts: () => import(
		/* webpackChunkName: "contacts" */ "./contacts/contacts"
  ),
  carousel: () => import(
		/* webpackChunkName: "carousel" */ "./carousel/carousel"
  ),
  sliderFull: () => import(
		/* webpackChunkName: "sliderFull" */ "./slider-full/slider-full"
  ),
  audioPlayer: () => import(
		/* webpackChunkName: "audioPlayer" */ "./audio-player/audio-player"
  ),
  prototype: () => import(
		/* webpackChunkName: "prototype" */ "./prototype/prototype"
  ),
  magazineIndex: () => import(
		/* webpackChunkName: "magazineIndex" */ "./magazine-index/magazine-index"
  ),
  magazineDetail: () => import(
		/* webpackChunkName: "magazineDetail" */ "./magazine-detail/magazine-detail"
  ),
  sliderRelated: () => import(
		/* webpackChunkName: "sliderRelated" */ "./slider-related/slider-related"
  ),
  maps: () => import(
		/* webpackChunkName: "maps" */ "./maps/maps"
  ),
  mapsInfo: () => import(
		/* webpackChunkName: "mapsInfo" */ "./maps-info/maps-info"
  ),
  mapsWineyard: () => import(
		/* webpackChunkName: "mapsWineyard" */ "./maps-wineyard/maps-wineyard"
  ),
  sickyButton: () => import(
		/* webpackChunkName: "stickyButton" */ "./sticky-button/sticky-button"
  )
};

export { getModules };
